import { useCallback } from "react";

export const useFitZoom = ({
  onFitZoomComputed,
  zoomableComponentId,
  zoomableComponentRealSize,
}: {
  onFitZoomComputed: (fittedZoom: number) => void;
  zoomableComponentId: string;
  zoomableComponentRealSize: { width: number; height: number };
}) =>
  useCallback(() => {
    const container = document.getElementById(zoomableComponentId);
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const availableWidth = containerRect.width - 50;
    const availableHeight = containerRect.height - 50;

    const {
      width: zoomableComponentRealWidth,
      height: zoomableComponentRealHeight,
    } = zoomableComponentRealSize;
    const scaleX = availableWidth / zoomableComponentRealWidth;
    const scaleY = availableHeight / zoomableComponentRealHeight;

    onFitZoomComputed(Math.min(scaleX, scaleY, 1));
  }, [onFitZoomComputed, zoomableComponentRealSize, zoomableComponentId]);
